import React, { useMemo } from "react";
import "../../styles/audiobook/ConfirmAudioBookModal.scss";
import { Player } from "@lottiefiles/react-lottie-player";
import useAppTranslation from "../../hooks/useAppTranslation";

const ConfirmAudioBookModal = ({ bookTitle, onConfirm, onCancel }) => {
  const { t } = useAppTranslation("components/audiobook/confirmAudioBookModal");
  const lottieAnimations = [
    "/lottie/making-arial.json",
    "/lottie/making-nikki.json",
  ];

  const randomLottie = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * lottieAnimations.length);
    return lottieAnimations[randomIndex];
  }, []);

  return (
    <div className="audio-modal-overlay">
      <div className="modal-box">
        <Player src={randomLottie} autoplay loop className="making-arial" />
        <p>
          <span>{bookTitle}</span>
          <br />
          {t("confirmMessage")}
        </p>
        <div className="modal-buttons">
          <button type="button" className="confirm-btn" onClick={onConfirm}>
            <span>{t("actions.confirm")}</span>
          </button>
          <button type="button" className="cancel-btn" onClick={onCancel}>
            <span>{t("actions.close")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAudioBookModal;
